import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import {showError} from '../Common/notification'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import './styles.css'
import moment from 'moment'

const styles = theme => ({
    root: {
      zIndex: 1200,
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '-5px 4px 10px #8E8E8E29',
      borderRadius: '21px',
      opacity: 1,
      padding: '0px !important',
      minWidth: '300px'
    },
    rootDialog: {
        zIndex: 1250,
    },
});

class Contenido extends React.Component {

    over = null;

    dragStart(e) {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', this.dragged);
    }

    dragEnd(e) {
        // update state
        var from = Number(this.dragged.dataset.id);
        var to = Number(this.over);
        if (from!==to && to!==-1){
            if(this.props.canSwap === false){ showError("No se permite ordenar los items de una busqueda. Por favor limpie la busqueda."); return; }
            this.props.handleOnSwap(from, to)
        }
    }

    dragOver(e) {
        e.preventDefault();
        if(e.target.className === 'placeholder') return;
        if(e.target.dataset.id){
            this.over = e.target.dataset.id;
            e.target.style = e.target.style + "background-color:yellow;" 
            }        
    }

    renderSearchBar = () => {
        return (
            <Row className='searchBar'>
                <Col>
                    <TextField 
                        className='filterInput'
                        select                   
                        value={this.props.tipoContenidoSelected}
                        name='idTipoContenido'
                        onChange={this.props.handleOnChangeTipoContenido}
                        placeholder="Tipo Contenido"
                    >
                        {/*<MenuItem key={0} value={0}>
                            {'Todos los contenidos'}
                        </MenuItem>*/}

                        {this.props.tiposContenido && this.props.tiposContenido.map((e) => 
                            <MenuItem key={e.idTipoContenido} value={e.idTipoContenido}>
                                {e.nombre}
                            </MenuItem>
                        )}
                    </TextField>
                </Col>
            </Row>)
    }

    render() {
        const { classes } = this.props;

        return (
            <div data-id={-1} onDragOver={this.dragOver.bind(this)}>
                {/* menú superior */}
                <TitleBar 
                    title={'Contenidos'}
                    searchBar={this.renderSearchBar()} 
                    handleOnSearch={this.props.handleOnClickBuscar}
                    searchPlaceholder="Contenido"
                    showSearch = {true}
                    newButtonLink='/Contenido/Nuevo'
                />

                <Paper 
                    onDragOver={this.dragOver.bind(this)} 
                    style={{
                        backgroundColor: "transparent", 
                        boxShadow:'none'
                    }}
                >
                    <Row style={{margin: '0px'}}>
                        {this.props.contenidos && this.props.contenidos.map((x,i) => {
                            return x.activo === true ?
                                <Col 
                                    md={6} lg={4}
                                    className='draggable' 
                                    data-id={x.idContenido} 
                                    draggable='true' 
                                    onDragEnd={this.dragEnd.bind(this)} 
                                    onDragStart={this.dragStart.bind(this)}
                                >
                                    <div className='containerItemContenido'>

                                        <div className='containerInfoItem'>
                                            <div className='imgItem'> 
                                                {<img src={this.props.tipoContenidoSelectedImg  && this.props.tipoContenidoSelectedImg  !== 3 ? x.pathImagen : require('../../images/AvatarPreguntasFrecuentes.png')} onDragStart={(e)=>{e.preventDefault();}} alt=""/>}
                                            </div>
                                            <div className='infoItem'>
                                                <div className='textoContenido'>{x.textoCorto.slice(0, 25) + (x.textoCorto.length > 25 ? '...' : '')}</div>
                                                {(x.fechaActivacion && x.fechaDesactivacion )&& <div>Desde {`${moment(x.fechaActivacion, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}`} hasta {`${moment(x.fechaDesactivacion, 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}`}</div>}
                                                <div>{`${x.nombreUsuarioRegistro}`}</div>
                                                {/* <div>{x.activo === true ? 'Activo' : 'Inactivo'}</div> */}
                                            </div>
                                        </div>

                                        <div onClick={(e)=>{e.stopPropagation()}}>
                                            <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                                                {popupState => (
                                                    <React.Fragment>
                                                        <IconButton {...bindTrigger(popupState)}>
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        <Menu {...bindMenu(popupState)}>
                                                            <MenuItem onClick={(...args) => {this.props.handleOnClickVer(x); popupState.close(...args)}}>Ver</MenuItem>
                                                            <MenuItem>
                                                                <Link 
                                                                    to={{
                                                                        pathname: `/Contenido/Editar/${x.idContenido}`,
                                                                        key: Math.random(),
                                                                        state: {
                                                                        applied: true
                                                                        }
                                                                    }} 
                                                                    style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
                                                                >
                                                                    Editar
                                                                </Link>
                                                            </MenuItem>
                                                            <MenuItem onClick={(...args) => {this.props.handleOnClickBorrar(x, false); popupState.close(...args)}}>Borrar</MenuItem>
                                                        </Menu>
                                                    </React.Fragment>
                                                )}
                                            </PopupState>
                                        </div>

                                        {/*(props.activo !== true) && <div style={{float:"right", fontWeight:"normal", position:"relative",fontFamily:"Roboto",color:"#FFFFFF", backgroundColor:"#E21B1B", borderRadius:"2px",padding:"1px 8px", marginRight:"5px",fontSize:"14px", top:"-10px"}}>{"Inactivo"}</div>*/}
                                    
                                    </div>
                                </Col>
                            :
                            undefined 
                        })}
                        {(this.props.contenidos === undefined || this.props.contenidos.length === 0) &&
                        <div className='noContenidos'>No se encontraron contenidos activos para el tipo de contenido seleccionado</div>
                        }
                    </Row>
                
                </Paper>

                {/* VER */}
                <Dialog
                    classes={{root: classes.rootDialog, paperScrollPaper: classes.root}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    open={this.props.openModalVer}
                    fullWidth={true}
                >
                <DialogContent classes={{root: classes.root}}>

                    <Row style={{margin: '0px'}}>

                        <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModalVer'>
                                <div className='titleModal'>{this.props.itemSelectedVer ? this.props.itemSelectedVer.textoCorto : ''}</div>
                                
                                {this.props.itemTipoContenidoSelected && this.props.itemTipoContenidoSelected.idTipoContenido !== 3 ?
                                    <div className='imgModal'>
                                        <img src={this.props.itemSelectedVer ? this.props.itemSelectedVer.pathImagen : ''} alt=""></img>
                                    </div>
                                :
                                    <div className='textoLargo'>
                                        {this.props.itemSelectedVer ? this.props.itemSelectedVer.textoLargo : ''}
                                    </div>
                                }

                                <div className='containerButtonsModal'>
                                    <Button className='btnCerrarModal' onClick={this.props.handleOnClickCerrarModal}>
                                        CERRAR
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    
                    </Row>

                    </DialogContent>
                </Dialog>
                
                {/* EDITAR */}
                <Dialog
                    classes={{root: classes.rootDialog, paperScrollPaper: classes.root}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    open={this.props.openModalVer}
                    fullWidth={true}
                >
                <DialogContent classes={{root: classes.root}}>

                    <Row style={{margin: '0px'}}>

                        <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModalVer'>
                                <div className='titleModal'>{this.props.itemSelectedVer ? this.props.itemSelectedVer.textoCorto : ''}</div>
                                {this.props.itemTipoContenidoSelected && this.props.itemTipoContenidoSelected.idTipoContenido !== 3 ?
                                    <div className='imgModal'>
                                        <img src={this.props.itemSelectedVer ? this.props.itemSelectedVer.pathImagen : ''} alt=""></img>
                                    </div>
                                :
                                    <div className='textoLargo'>
                                        {this.props.itemSelectedVer ? this.props.itemSelectedVer.textoLargo : ''}
                                    </div>
                                }

                                <div className='containerButtonsModal'>
                                    <Button className='btnCerrarModal' onClick={this.props.handleOnClickCerrarModal}>
                                        CERRAR
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    
                    </Row>

                    </DialogContent>
                </Dialog>


                
                {/* CONFIRMAR BORRAR */}
                <Dialog
                    classes={{root: classes.rootDialog, paperScrollPaper: classes.root}}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth='sm'
                    open={this.props.openModalBorrar}
                    fullWidth={true}
                >
                <DialogContent classes={{root: classes.root}}>

                    <Row style={{margin: '0px'}}>

                        <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModalVer'>
                                <div className='titleModal'>Está seguro que desea borrar el contenido?</div>

                                <div className='containerButtonsModal'>
                                    <Button className='btnCerrarModal' onClick={this.props.handleOnClickCerrarModal}>
                                        CERRAR
                                    </Button>
                                    <Button className='btnBorrarModal' onClick={() => this.props.handleOnClickBorrar(undefined, true)}>
                                        BORRAR
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    
                    </Row>

                    </DialogContent>
                </Dialog>

            </div>
        )
    }
}

Contenido.propTypes = {
    handleOnSearch : PropTypes.func.isRequired,
    tipoContenidoSelected: PropTypes.number.isRequired,
    tiposContenido: PropTypes.array.isRequired,
    itemTipoContenidoSelected: PropTypes.object,
    contenidos: PropTypes.array.isRequired,
    openModalVer: PropTypes.bool,
    itemSelectedVer: PropTypes.object,
    itemSelectedEditar: PropTypes.object,
    openModalBorrar: PropTypes.bool,
    handleOnChangeTipoContenido: PropTypes.func.isRequired,
    handleOnClickBuscar: PropTypes.func.isRequired,
    handleOnClickVer: PropTypes.func.isRequired,
    handleOnClickEditar: PropTypes.func.isRequired,
    handleOnClickBorrar: PropTypes.func.isRequired,
    handleOnClickCerrarModal: PropTypes.func.isRequired,
    handleOnSwap: PropTypes.func.isRequired,
}

Contenido.defaultProps = {
    tiposContenido: [],
    contenidos: [],
    canSwap: true,
    openModalVer:false,
    itemSelectedVer: undefined,
    itemSelectedEditar: [],
    handleOnChangeTipoContenido: f => f,
    handleOnClickBuscar: f => f,
    handleOnClickVer: f => f,
    handleOnClickEditar: f => f,
    handleOnClickBorrar: f => f,
    handleOnClickCerrarModal: f => f,
    handleOnSwap: f => f,
}

export default withStyles(styles)(Contenido)